import { Wording } from '@/types';

export const ASTROLOGY_WORDING_BG: Wording = {
  components_header_media_content: 'Aудиозаписи',
  components_header_media_1: 'Медитации',
  components_header_media_2: 'Подкаст',
  components_header_text1: 'Ръководства',
  components_header_text2: 'Блог',
  components_header_members: 'Членове',
  hero_text: 'Изследвайте звездите отвътре',
  hero_button_text: 'Започнете тук',
  components_ressources_section_title: 'РЕСУРСИ',
  components_ressources_subheader_text: 'Всички инструменти, от които се нуждаете за космическо прозрение и себеоткриване',
  components_ressources_span_text: 'Разширете вътрешната си вселена с подбрана комбинация от подкасти и статии. Независимо дали търсите космическо прозрение, яснота или духовно изравняване, нашите ресурси ви помагат да се свържете с астрологията по практични и смислени начини.',
  components_ressources_card_1_title: 'Дълбоки гмуркания',
  components_ressources_card_1_text: 'Гмурнете се в богата колекция от задълбочени подкасти, обхващащи астрология, таро, космически архетипи и духовно израстване - предназначени да разширят вашето съзнание и да задълбочат вашата практика.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text: 'Астрологични съвети и публикации в блогове за самоосъзнаване и душевен растеж.',
  components_ressources_link: 'Разгледайте допълнително',
  components_notes_and_google_title_1: 'Астрологично ръководство',
  components_notes_and_google_title_2: 'Космическа рутина',
  components_notes_and_google_title_3: 'Размисли',
  components_review_google_text: 'Отзиви',
  media_content_section_title: 'АУДИО',
  media_content_section_subheader_text: 'Нашият подкаст',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Още епизоди',
  text2_section_title: 'БЛОГ',
  text2_section_subheader_text: 'Статии и прозрения',
  text2_section_button_more: 'Зареди още',
  components_text1_section_title: 'РЪКОВОДСТВА',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Вижте всички ръководства',
  components_footer_text: 'Събудете своя вътрешен космос: вашият път, вашите звезди.',
  components_footer_info: 'Информация',
  components_footer_registration_number: 'Регистрационен номер',
  components_footer_legal: 'Законни',
  components_footer_terms: 'Правила и условия',
  components_footer_privacy: 'Политика за поверителност',
  button_load_more: 'Зареди още',
  page_media_1_content_hero_text: 'Подкаст епизоди',
  page_media_content_menu_foundations: 'Основи',
  page_media_content_menu_spirituality: 'Духовност',
  page_media_content_menu_tarot: 'Таро',
  page_media_content_menu_psychology: 'Психология',
  page_media_content_menu_trends: 'Тенденции',
  page_media_2_content_hero_text: 'Медия 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Нашият блог',
  page_text2_section_title: 'Блог',
  page_text2_subheader_text: 'Статии и прозрения',
  enter_email_title: 'Моля, въведете вашия имейл, за да продължите',
  enter_email_placeholder_email: 'Имейл',
  enter_email_button_enter: 'Въведете',
  components_login_success_text: 'Успешно влизане!',
  components_card_link_media_content: 'Слушай сега',
  components_card_link_text1_content: 'Вижте ръководството',
  components_card_link_text2_content: 'Вижте статията',
  france: 'Франция',
  cyprus: 'Кипър',
  tag_podcast: 'Подкаст',
  tag_meditation: 'Медитация',
  page_media_content_menu_all: 'Всички',
};